import React, { useRef, useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";

import AuthService from "../../../../services/User/AuthService";
import DeveloperApiService from "../../../../services/User/DeveloperApiService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const Webhooks = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const rechargeRef = useRef();

  const submitHandler = async () => {
    const recharge = rechargeRef.current.value;

    const urls = {
      recharge: recharge,
    };

    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await DeveloperApiService.webhooks(token, urls);

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }

    loadingCtx.stopLoading();
  };

  const data = props.data ? JSON.parse(props.data.callback_urls) : null;

  return (
    <React.Fragment>
      <div className="mt-3 mb-3">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div class="form-group">
              <label for="exampleInputEmail1">Recharge Webhook URL</label>
              <input
                type="text"
                class="form-control"
                placeholder="Ex: https://www.yourdomain.com/recharge_response"
                ref={rechargeRef}
                defaultValue={data ? data.recharge : ""}
              />
              <small>
                Sample URL:{" "}
                <span style={{ color: "red" }}>
                  https://www.yourdomain.com/recharge_response
                </span>
                <br /> We will add:{" "}
                <span style={{ color: "red" }}>
                  ?order_id= &p_order_id=&number= &amount= &status=&message=
                  &operator_ref_id=
                </span>
              </small>
            </div>

            <div className="text-center plan-btn mt-2 mb-2">
              <Button
                color="primary"
                onClick={() => {
                  submitHandler();
                }}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Webhooks;
